import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { AppButton, AppCardDescription, AppCardHeader, AppCardTitle } from '../../../ui';

/**
 * CardHead — the header every card on the trainer dashboard shares: a title, an
 * optional one-line description, and a link to the page with the full story.
 *
 * Local to this screen, like `StudentProfile/RecordCardHead`: one screen's
 * cards, not yet the three screens that earn a place in `ui/`.
 *
 * Props:
 *   id          — put on the title, so the card can be `aria-labelledby` it
 *   title       — the card's name
 *   description — one short line under it
 *   linkTo      — route for the trailing "View all →" link
 *   linkLabel   — that link's text
 */
const CardHead = ({ id, title, description, linkTo, linkLabel }) => (
  <AppCardHeader className="tw-flex-row tw-items-start tw-justify-between tw-gap-3">
    <div className="tw-min-w-0">
      <AppCardTitle id={id} as="h2">{title}</AppCardTitle>
      {description && <AppCardDescription>{description}</AppCardDescription>}
    </div>
    {linkTo && (
      <AppButton as={Link} to={linkTo} size="sm" variant="ghost" className="tw-shrink-0">
        {linkLabel} <ArrowRight size={16} aria-hidden="true" />
      </AppButton>
    )}
  </AppCardHeader>
);

export default CardHead;
